/**
 * 项目配置信息
 * 包含多个项目的详细信息，每个项目包括名称和对应的值。
 * 这些项目代表了不同的农业产业服务项目。
 * 
 * @type {Object}
 * @property {Object} xinglong - 兴隆山楂全产业链高质量发展项目
 * @property {Object} hnzyc - 华南优质中药材数字交易中心
 * @property {Object} kyzq - 科右大数据
 * @property {Object} pengyang - 彭阳县优质农产品全产业链
 * @property {Object} test - 测试大数据
 * @property {Object} inner-trade - 新盟风控
 */
let projectAll = {
  'wulate': {
    name: "乌拉特前期",
    value: "wulate",
    goods:{
      nameShow: true,
    },
    chat:{
      SDKAppID: "1400816559",
    },
    map:{
      tdt:{
        tk:'207a7b31f8588ba2a8df864d967b6c15'
      }
    }
  },
  'xinglong': {
    name: "兴隆山楂全产业链高质量发展项目",
    value: "xinglong",
    goods:{
      nameShow: true,
    },
    chat:{
      SDKAppID: "1400816559",
    },
    map:{
      tdt:{
        tk:'207a7b31f8588ba2a8df864d967b6c15'
      }
    }
  },
  'hnzyc': {
    name: "华南优质中药材数字交易中心",
    value: "hnzyc",
    goods:{
      nameShow: true,
    },
    chat:{
      SDKAppID: "1400816559",
    },
    map:{
      tdt:{
        tk:'207a7b31f8588ba2a8df864d967b6c15'
      }
    }
  },
  'kyzq': {
    name: "科右中旗",
    value: "kyzq",
    goods:{
      nameShow: true,
    },
    chat:{
      SDKAppID: "1400816559",
    },
    map:{
      tdt:{
        tk:'207a7b31f8588ba2a8df864d967b6c15'
      }
    }
  },
  'pengyang': {
    name: "彭阳县优质农产品全产业链",
    value: "pengyang",
    goods:{
      nameShow: true,
    },
    chat:{
      SDKAppID: "1400816559",
    },
    map:{
      tdt:{
        tk:'207a7b31f8588ba2a8df864d967b6c15'
      }
    }
  },
  'pingLe': {
    name: "平乐柿子",
    value: "pingLe",
    goods:{
      nameShow: true,
    },
    chat:{
      SDKAppID: "1400816559",
    },
    map:{
      tdt:{
        tk:'207a7b31f8588ba2a8df864d967b6c15'
      }
    }
  },
  'qqshangtong': {
    name: "全球商通中心",
    value: "qqshangtong",
    goods:{
      nameShow: false,
    },
    chat:{
      SDKAppID: "1400816559",
      adminID: "8916798901268061012"
    },
    map:{
      tdt:{
        tk:'207a7b31f8588ba2a8df864d967b6c15'
      }
    },
    redirectUrl:"https://nfstzx.com",
  },
  'inner-trade': {
    name: "新盟风控",
    value: "inner-trade",
    goods:{
      nameShow: true,
    },
    chat:{
      SDKAppID: "1400816559",
      adminID: "5099089655853693080"
    },
    map:{
      tdt:{
        tk:'207a7b31f8588ba2a8df864d967b6c15'
      }
    }
  },
  'test': {
    name: "测试环境",
    value: "test",
    goods:{
      nameShow: true,
    },
    chat:{
      SDKAppID: "1400816559",
      adminID: "4614796646178551665"
    },
    map:{
      tdt:{
        tk:'207a7b31f8588ba2a8df864d967b6c15'
      }
    }
  },
  'developement': {
    name: "开发环境",
    value: "developement",
    goods:{
      nameShow: true,
    },
    chat:{
      SDKAppID: "1400816559",
      adminID: "4614796646178551665"
    },
    map:{
      tdt:{
        tk:'207a7b31f8588ba2a8df864d967b6c15'
      }
    }
  },
  'common': {
    name: "公共开发配置",
    value: "common",
    goods:{
      nameShow: true,
    },
    chat:{
      SDKAppID: "1400816559",
    },
    map:{
      tdt:{
        tk:'207a7b31f8588ba2a8df864d967b6c15'
      }
    }
  }
}
module.exports = projectAll